<script setup lang="ts">
import { useLayoutLoader } from '@/composables/useLayoutLoader'

const { isLoading: loading } = useLayoutLoader()
</script>

<template>
  <div class="w-full h-screen flex items-center justify-center">
    <LayoutLoader :loading="loading">
      <Container>
        <div>
          <RouterView v-slot="{ Component }">
            <transition name="fade" mode="out-in">
              <component :is="Component" />
            </transition>
          </RouterView>
        </div>
      </Container>
    </LayoutLoader>
  </div>
</template>
